import React, {Component} from 'react';
import PropTypes from "prop-types";
import SettingsFormBig from './SettingsFormBig'
import SettingsFormSide from "./SettingsFormSide";
import userImage from "../../assets/128x128.jpg";
import api from '../../utils/api';
import {Link} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import countries from '../Common/Countries';
import ContactType from '../Common/ContactType';
import Relation from '../Common/Relation';
import AvatarModalContainer from '../../containers/Dashboard/DashboardUser/AvatarModalContainer';
import OfficialTest from './OfficialTest';
import { NotificationManager } from 'react-notifications';

class Settings extends Component {
    constructor(props){
        super(props);
        this.state = {
            profile: null,
            user: {
                password: '',
                oldPassword: '',
                passwordAgain: ''
            },
            tabs: [
                {name: 'Personal', url: 'personal'},
                {name: 'Contact', url: 'contact'},
                {name: 'Environment', url: 'environment'},
                {name: 'Past Tests', url: 'past-tests'},
                {name: 'Notifications', url: 'notifications'}
            ],
            personalSections: [
                {
                    name: 'Update Profile Info',
                    obj: 'profile',
                    sectionClass: 'col-md-8',
                    rightSide: 'avatar',
                    icon: 'zmdi-account',
                    fields: [
                        {
                            label: 'First Name',
                            placeholder: 'First Name',
                            type: 'text',
                            key: 'name'
                        },
                        {
                            label: 'Middle Name',
                            placeholder: 'Middle Name',
                            type: 'text',
                            key: 'mname'
                        },
                        {
                            label: 'Last Name',
                            placeholder: 'Last Name',
                            type: 'text',
                            key: 'lname'
                        },
                        {
                            label: 'Gender',
                            placeholder: 'Gender',
                            type: 'select',
                            key: 'gender',
                            options: [
                                {value: '', label: 'Choose'},
                                {value: 'Male', label: 'Male'},
                                {value: 'Female', label: 'Female'}
                            ]
                        },
                        {
                            label: 'Date of Birth',
                            placeholder: 'Date of Birth',
                            type: 'date',
                            key: 'birthdate'
                        }
                    ]
                },
                {
                    name: 'Update Account Info',
                    obj: 'user',
                    icon: 'zmdi-account',
                    fields: [
                        
                        {
                            label: 'New Password',
                            placeholder: 'New Password',
                            type: 'password',
                            key: 'password'
                        },
                        {
                            label: 'New Password (Again)',
                            placeholder: 'New Password',
                            type: 'password',
                            key: 'passwordAgain'
                        }
                    ]
                }
            ],
            notificationSections: [
                {
                    name: 'General',
                    obj: 'profile',
                    subObject: 'settings',
                    icon: 'zmdi-pin',
                    subSections: [
                        {
                            name: "Account",
                            fields: [
                                  {
                                    label: 'Standing',
                                    placeholder: 'Standing',
                                    type: 'render',
                                    key: 'name',
                                    value: <span className="text-success">Good</span>,
                                    className: 'text-success'
                                }
                            ]
                        },
                        {
                            name: "Sounds",
                            fields: [
                                  {
                                    label: 'Notifications',
                                    placeholder: 'Standing',
                                    type: 'check',
                                    key: 'notificationSounds'
                                },
                                {
                                    label: 'Music Volume',
                                    type: 'slider',
                                    key: 'musicVolume'
                                }, 
                            ]
                        },
                        {
                            name: "Email Notifications",
                            fields: [
                                  {
                                    label: 'Announcements',
                                    type: 'check',
                                    key: 'emailAnnouncements'
                                },
                                {
                                    label: 'Red Flags',
                                    type: 'check',
                                    key: 'emailFlags'
                                },
                                {
                                    label: 'Days Remaining to finish subject',
                                    type: 'check',
                                    key: 'emailDaysRemaining'
                                },
                                {
                                    label: 'Offers',
                                    placeholder: 'Offers',
                                    type: 'check',
                                    key: 'emailOffers'
                                },
                            ]
                        },
                        {
                            name: "Live Feed",
                            fields: [
                                  {
                                    label: 'Share my score',
                                    type: 'check',
                                    key: 'shareScore'
                                },
                                {
                                    label: 'Share my quiz scores',
                                    type: 'check',
                                    key: 'shareQuizScore'
                                }
                            ]
                        }
                    ]
                }
            ],
            environmentSections: [
                {
                    name: 'Committments',
                    obj: 'profile',
                    subObject: 'personal',
                    icon: 'zmdi-pin',
                    fields: [
                        {
                            label: 'During preparation, what best describes the number of hours you will work?',
                            placeholder: '',
                            type: 'text',
                            key: 'workingHours',
                            horizontal: true,
                            fieldClass: 'col-md-3'
                        },
                        {
                            label: 'During preparation, what best describes the number of hours you will study for school?',
                            placeholder: '',
                            type: 'text',
                            key: 'schoolHours',
                            horizontal: true,
                            fieldClass: 'col-md-3'
                        },
                        {
                            label: 'During preparation, what best describes the number of hours you will spend on extracurricular activities?',
                            placeholder: '',
                            type: 'text',
                            key: 'activityHours',
                            horizontal: true,
                            fieldClass: 'col-md-3'
                        }
                    ]
                },
                {
                    name: 'Environment',
                    obj: 'profile',
                    subObject: 'personal',
                    icon: 'zmdi-pin',
                    fields: [
                        {
                            label: 'You Live',
                            placeholder: '',
                            type: 'select',
                            key: 'living',
                            horizontal: true,
                            fieldClass: 'col-md-3',
                            options: [
                                {value: '', label: 'Select'},
                                {value: 'Alone', label: 'Alone'},
                                {value: 'With roommates', label: 'With roommates'},
                                {value: 'With family', label: 'With family'}]
                        },
                        {
                            label: 'You have a private room or study space at my home',
                            placeholder: '',
                            type: 'select',
                            key: 'room',
                            horizontal: true,
                            fieldClass: 'col-md-3',
                            options: [
                                {value: '', label: 'Select'},
                                {value: 'Yes', label: 'Yes'},
                                {value: 'No', label: 'No'},
                            ]
                        },
                        {
                            label: 'In some way, you look after how many people? These could include parents, siblings, spouse or children',
                            placeholder: '',
                            type: 'select',
                            key: 'dependents',
                            horizontal: true,
                            fieldClass: 'col-md-3',
                            options: [
                                {value: '', label: 'Select'},
                                {value: '0', label: '0'},
                                {value: '1', label: '1'},
                                {value: '2', label: '2'},
                                {value: '3', label: '3'},
                                {value: '4', label: '4'},
                                {value: '5', label: '5'},
                            ]
                        }
                    ]
                }
            ],
            contactSections: [
                {
                    name: 'Mailing Address',
                    obj: 'profile',
                    icon: 'zmdi-pin',
                    fields: [
                        {
                            label: 'Address Line 1',
                            placeholder: 'Address Line 1',
                            type: 'text',
                            key: 'address1',
                            vertical: true,
                            containerClass: 'col-md-6'
                        },
                        {
                            label: 'Country',
                            placeholder: 'Country',
                            type: 'select',
                            key: 'country',
                            vertical: true,
                            containerClass: 'col-md-3',
                            options: countries
                        },
                        {
                            label: 'State/Province',
                            placeholder: 'State/Province',
                            type: 'text',
                            key: 'district',
                            vertical: true,
                            containerClass: 'col-md-3'
                        },
                        {
                            label: 'Address Line 2',
                            placeholder: 'Address Line 2',
                            type: 'text',
                            key: 'address2',
                            vertical: true,
                            containerClass: 'col-md-6'
                        },
                        {
                            label: 'City',
                            placeholder: 'City',
                            type: 'text',
                            key: 'city',
                            vertical: true,
                            containerClass: 'col-md-3'
                        },
                        {
                            label: 'Zip/Postal Code',
                            placeholder: 'Zip/Postal Code',
                            type: 'text',
                            key: 'postalCode',
                            vertical: true,
                            containerClass: 'col-md-3'
                        }
                    ]
                },
                {
                    name: 'Contact Information',
                    obj: 'profile',
                    icon: 'zmdi-email',
                    fields: [
                        {
                            label: 'Contact Type',
                            placeholder: 'Contact Type',
                            type: 'select',
                            key: 'phonetype',
                            vertical: true,
                            containerClass: 'col-md-3',
                            options: ContactType
                        },
                        {
                            label: 'Country Code',
                            placeholder: 'Country Code',
                            type: 'text',
                            key: 'phonecountry',
                            vertical: true,
                            containerClass: 'col-md-3'
                        },
                        {
                            label: 'Contact Number',
                            placeholder: 'Contact Number',
                            type: 'text',
                            key: 'phone',
                            vertical: true,
                            containerClass: 'col-md-6'
                        },
                    ]
                },
                {
                    name: 'Emergency Contact Information',
                    obj: 'profile',
                    icon: 'zmdi-email',
                    fields: [
                        {
                            label: 'Relationship',
                            placeholder: 'Relationship',
                            type: 'select',
                            key: 'ecrel',
                            vertical: true,
                            containerClass: 'col-md-3',
                            options: Relation
                        },
                        {
                            label: 'Contact Name',
                            placeholder: 'Contact Name',
                            type: 'text',
                            key: 'ecname',
                            vertical: true,
                            containerClass: 'col-md-9'
                        },
                        {
                            label: 'Contact Type',
                            placeholder: 'Contact Type',
                            type: 'select',
                            key: 'ectype',
                            vertical: true,
                            containerClass: 'col-md-3',
                            options: ContactType
                        },
                        {
                            label: 'Country Code',
                            placeholder: 'Country Code',
                            type: 'text',
                            key: 'eccountry',
                            vertical: true,
                            containerClass: 'col-md-3'
                        },
                        {
                            label: 'Contact Number',
                            placeholder: 'Contact Number',
                            type: 'text',
                            key: 'ecnumber',
                            vertical: true,
                            containerClass: 'col-md-6'
                        },
                    ]
                },
                {
                    name: 'Parent/Guardian Contact Information',
                    obj: 'profile',
                    icon: 'zmdi-email',
                    fields: [
                        {
                            label: 'Relationship',
                            placeholder: 'Relationship',
                            type: 'select',
                            key: 'prel',
                            vertical: true,
                            containerClass: 'col-md-3',
                            options: Relation
                        },
                        {
                            label: 'Contact Name',
                            placeholder: 'Contact Name',
                            type: 'text',
                            key: 'pname',
                            vertical: true,
                            containerClass: 'col-md-9'
                        },
                        {
                            label: 'Contact Type',
                            placeholder: 'Contact Type',
                            type: 'select',
                            key: 'ptype',
                            vertical: true,
                            containerClass: 'col-md-3',
                            options: ContactType
                        },
                        {
                            label: 'Country Code',
                            placeholder: 'Country Code',
                            type: 'text',
                            key: 'pcountry',
                            vertical: true,
                            containerClass: 'col-md-3'
                        },
                        {
                            label: 'Contact Number',
                            placeholder: 'Contact Number',
                            type: 'text',
                            key: 'pnumber',
                            vertical: true,
                            containerClass: 'col-md-6'
                        },
                    ]
                }
            ]
        }
    }


    //Actions
    onBasicInfoUpdate = (update) => {
        update.id = this.props.profile.id;
        this.props.updateProfile(update, this.props.user.id);
    };
    onContactsInfoUpdate = (update) => {
        update.id = this.props.profile.id;
        this.props.updateProfile(update, this.props.user.id);
    };

    updateUser = (update) => {
        update.id = this.props.user.user.id;
        this.props.updateUser(this.props.user.id, update);
    }
    
    componentDidMount(){

        let newLog = {
            date: new Date(),
            duration: 0,
            type: 'Settings',
            subject: '',
            chapter: '',
            activity: '',
            score: '',
            courseUserId: this.props.courseUser[0].id,
            userId: this.props.user.user.id
        }

        this.props.createLog(newLog, this.props.user.id);
        if(this.props.profile && !this.state.profile){
            if(!this.props.profile.settings){
                this.props.profile.settings = {};
            }
            this.setState({profile: JSON.parse(JSON.stringify(this.props.profile))});
        }
        this.props.getOfficialTests(this.props.profile.id, this.props.user.id);
    }
    
    componentWillUnmount(){
        let {currentLog} = this.props;
        if(currentLog){
            currentLog.end = new Date();
            this.props.updateLog(currentLog, this.props.user.id);
        }
    }
    
    
    //Renders
    renderHeader = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">Settings</h1>
                    <small className="text-muted">Manage your profile info</small>

                </div>
            </div>
        </div>
    );
    
    updateProfileField = (obj, subObject, field, value) => {
        let {profile, user} = this.state;
        if(obj === 'profile'){
            if(subObject){
                profile[subObject][field] = value;
            }else{
                profile[field] = value;
            }
        }else if(obj === 'user'){
           user[field] = value; 
            
        }
        this.setState({profile, user});
    }
    
    renderTabs = () => {
        return (
            <div className="setting-header-nav">
                <ul className="header-nav">
                    {this.state.tabs.map(t => {
                        return this.renderTab(t)
                    })
                    }
                    
                </ul>
            </div>
        )
    }
    
    renderTab = (tab) => {
        return (
            <li className={tab.url === this.props.match.params.view ? 'active' : ''}>
            <Link to={'/settings/' + tab.url}>{tab.name}</Link>
            </li>
        )
    }
    
    saveObject = (obj) => {
        let {profile, user} = this.state;
        user.id = this.props.user.user.id;
        if(obj === 'profile'){
            this.props.updateProfile(profile, this.props.user.id);
        }else if(obj === 'user'){
            if(!user.password || !user.passwordAgain || (user.password !== user.passwordAgain)){
                NotificationManager.error("New Passwords don't match");
            }else{
                this.props.updateUser(this.props.user.id, user);
            }
        }
    } 
    
    renderLabel = (field) => {
        
    }
    
    renderSingleTest = (cu) => {
        return (
            <div className="foundationDiagnosticDivision sm-bottom10">
                            <div className="sp-top0">
                                <table className="table profile-info-table">
                                    <tbody><tr>
                                        <td>
                                            <span>Course</span>
                                            <h3 className="text-white">MCAT</h3>
                                        </td>
                                        <td>
                                            <span>Official Test Date</span>
                                            <h3>12 Feb 2017</h3>
                                        </td>
                                        <td>
                                            <span>Official Test Score</span>
                                            <h3>510</h3>
                                        </td>

                                        <td className="text-center">
                                            <div className="dropdown">
                                                <a href="#" className="btn MoreBtn font-20" data-toggle="dropdown"><i className="zmdi zmdi-more-vert"></i> </a>
                                                <ul className="dropdown-menu pull-right">
                                                    <li><a href="#" onclick="ToggleDiagnosticScores(this)">Expand</a> </li>
                                                    <li><a href="#AddTestTakenModal" data-toggle="modal">Edit</a> </li>
                                                    <li><a href="#" onclick="RemoveTestSection(this)">Delete</a> </li>
                                                </ul>
                                            </div>
                                        </td>

                                    </tr>
                                </tbody></table>
                            </div>
                            <div className="sm-top0 daignosticscores">
                                <div className="panel-heading">
                                    <div className="flex flex-justify-content-space-between flex-align-items-center">
                                        <h3 className="panel-title text-uppercase">Diagnostic Scores</h3>
                                        <div>

                                            <div className="btn-group">
                                                <a href="#" className="btn btn-default" onclick="MoveScrollArea('left')"><i className="zmdi zmdi-chevron-left"></i> </a>
                                                <a href="#" className="btn btn-default" onclick="MoveScrollArea('right')"><i className="zmdi zmdi-chevron-right"></i> </a>
                                            </div>

                                            <div className="btn-group">
                                                <a href="#" className="btn btn-primary" onclick="ToggleDiagnosticScores(this)"><i className="zmdi zmdi-close"></i> </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix diagnostic-score-wrapper">
                                    <div className="one-fifth text-center sp-20 diagnostic-score sectionsScore">
                                        <span>Sections</span>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>Physical Sciences</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="95">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="49"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>Chemical Sciences</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="45">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="30"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>CARS</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="80">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="40"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>Behavioral Sciences</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="70">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="27"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>Physical Sciences</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="95">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="49"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>Chemical Sciences</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="45">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="30"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>CARS</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="80">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="40"></span>/50</div>
                                        </div>
                                    </div>
                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                        <span>Behavioral Sciences</span>
                                        <div className="chart easyPieChartGraph" data-track-color="#e2d9d8" data-bar-color="#dd3333" data-line-width="10" data-percent="70">
                                            <div className="percentWrapper"><span className="counter" data-from="0" data-to="27"></span>/50</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>        
        )
    }
    
    renderTestsTaken = () => {
        return (
            <div className="panel customPanel">
            
                <div className="panel-heading">
                        <div className="panel-control">
                            <a href="#AddTestTakenModal" data-toggle="modal"> <i className="zmdi zmdi-plus font-30"></i> </a>
                        </div>
                    <h3 className="panel-title text-uppercase"><i className="zmdi zmdi-account sm-right20"></i> Update Tests Taken</h3>
                </div>
                <div className="panel-body">
                    {this.state.profile.CourseUser.map(cu => {
                        return this.renderSingleTest(cu);
                    })
                    }
                </div>
            </div>
        )
    }
    
    renderField = (field, obj, subObject) => {
        if(field.type === 'text'){
            return (
                <input 
                    type="text" 
                    className="form-control" 
                    value={subObject? this.state[obj][subObject][field.key] : this.state[obj][field.key]} 
                    name={field.key} 
                    onChange={e => this.updateProfileField(obj, subObject, field.key, e.target.value)}    
                />
            )
        }else if(field.type === 'select'){
            return (
                <div className="form-select-overlay">
                <select 
                    className="form-control" 
                    value={subObject? this.state[obj][subObject][field.key] : this.state[obj][field.key]} 
                    onChange={e => this.updateProfileField(obj, subObject, field.key, e.target.value)}   
                    >
                    {field.options.map(o => {
                        return (
                            <option value={o.value}>{o.label}</option>
                        )
                    })
                    }
                    
                </select>
                </div>
            )
        }else if(field.type === 'password'){
            return (
                <input 
                    type="password" 
                    className="form-control" 
                    value={this.state[obj][field.key]} 
                    name={field.key} 
                    onChange={e => this.updateProfileField(obj, subObject, field.key, e.target.value)}    
                />
            )
        }else if(field.type === 'date'){
            return (
                <DatePicker
                    selected={moment(this.state[obj][field.key])}
                    name={field.key}
                    className="form-control"
                    onChange={e => this.updateProfileField(obj, subObject, field.key, e)}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    yearDropdownItemNumber={15}
                />
            )
        }else if(field.type === 'render'){
            return (
                <div className="setting-section-row">
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="text-right">
                                <span>{field.label}</span>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <span className="text-green">{field.value}</span>
                        </div>
                    </div>
                </div>    
            )
        }else if(field.type === 'check'){
            
            return (
                <div className="setting-section-row">
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="text-right">
                                <span>{field.label}</span>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div>
                            <input 
                            type="checkbox" 
                            className={`ios8-switch ios-switch-small`} 
                            checked={subObject? this.state[obj][subObject][field.key] : this.state[obj][field.key]} 
                            onChange={e => this.updateProfileField(obj, subObject, field.key, !this.state[obj][subObject][field.key])} 
                            id={field.key + "toggle"} />
                            <label htmlFor={field.key + "toggle"}></label>

                        </div> 
                        </div>
                    </div>
                </div>
                   
            )
        }
    }
    
    renderSection = (section) => {
        return (
            <div className="panel customPanel">
                    <div className="panel-heading">
                        <h3 className="panel-title text-uppercase">
                        <i className={`zmdi ${section.icon} sm-right20`}></i>
                        {section.name}</h3>
                    </div>
                    <div className="panel-body">
                        {section.subSections ?
                            section.subSections.map(ss => {
                                return (
                                    <div className="setting-section">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <h4>{ss.name}</h4>    
                                            </div>
                                            <div className="col-md-9">
                                                {ss.fields.map(field => {
                                                    return this.renderField(field, section.obj, section.subObject)
                                                })
                                                }
            
                                            </div>    
                                        </div>
                                    </div>
                                )
                            })
                        :
                            <div className="row">
                                <div className={section.sectionClass ? section.sectionClass : "col-sm-12"}>
                                    {section.fields.map(field => {
                                        return (
                                            <span>
                                            {field.vertical ?
                                            <div className={field.containerClass || 'col-md-12'}>
                                                <div className="form-group">
                                                    <label>{field.label}</label>
                                                    {this.renderField(field, section.obj, section.subObject)}
                                                    <span className="help-block"></span>
                                                </div>
                                            </div>
                                            :
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <span className="text-right sp-top10 font-12">{field.label}</span>
                                                    </div>
                                                    <div className={field.fieldClass ? field.fieldClass : "col-sm-8"}>
                                                        {this.renderField(field, section.obj, section.subObject)}
                                                        
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            }
                                            </span>
                                        )
                                    })
                                    }
                                
    
                                </div>
                                {section.rightSide ?
                                    <div className="col-md-4">
                                        {section.rightSide === 'avatar' &&
                                            <AvatarModalContainer standalone={true} />
                                        }
                                    </div>
                                    : null
                                }
                               
                            </div>
                        }
                    </div>
                    <div className="panel-footer text-right">
                        <input type="submit" className="btn btn-primary w-100" value="Save" onClick={e => this.saveObject(section.obj)} />
                    </div>
                </div>
        )
    }
    
    renderContent = () => {
        switch(this.props.match.params.view){
            case 'personal':
                return this.state.personalSections.map(s => this.renderSection(s));
                break;
            case 'contact':
                return this.state.contactSections.map(s => this.renderSection(s));
                break;
            case 'environment':
                return this.state.environmentSections.map(s => this.renderSection(s));
                break;
            case 'past-tests':
                if(this.state.profile.CourseUser){
                    return (
                        <OfficialTest
                            tests={this.props.officialTests}
                            courses={this.props.allCourses}
                            profileId={this.props.profile.id}
                            addOfficialTest={test => this.props.updateOfficialTest(test, this.props.user.id)}
                            deleteOfficialTest={testId => this.props.deleteOfficialTest(testId, this.props.user.id)}
                        />
                    )
                }
                break;
            case 'notifications':
                return this.state.notificationSections.map(s => this.renderSection(s));
        }
    }
    
    uploadAvatar = (e) => {
        const data = new FormData();
        data.append('file', e.target.files[0], this.props.profile.id + "-" + new Date().getTime().toString() + "-" + e.target.files[0].name);

        this.props.uploadAvatar(data, this.props.profile.id, this.props.user.id);

        //this.props.onUpdateVideo(this.props.video);


    }

    render() {

        return (
            <div className="content-wrapper"
                 id="content-container"
            >
                {this.renderHeader()}
                {this.renderTabs()}
                <section className="content form-wizard">
                    <div className="setting-content">
                
                    {this.state.profile &&
                        this.renderContent()}
                    </div>
                </section>
            </div>
        )
    }
    
    renderOld(){
        return (
            
                    <div className="row">
                        <div className="col-sm-8">
                        
                            <div className="form-section">
                                <h3 className="form-heading">
                                <i className="zmdi zmdi-image-alt sm-right20 form-icon"/>
                                Avatar</h3>
                                <div className="form-section-body text-center">
                                   
                                    <div className="row">
                                    {this.props.profile.image ?
                                        <img
                                            className="avatar center"
                                            src={api.makeFileURL(this.props.profile.image, this.props.user.id) || userImage}
                                            alt="user"
                                        />
                                        
                                        :
                                        <img
                                            className="avatar center"
                                            src={userImage}
                                            alt="user"
                                        />
                                        
                                    }
                                        <span className="btn btn-default btn-file">
                                            <span className="fileinput-new">
                                                <i className="zmdi zmdi-upload"/>
                                                Upload New Avatar
                                            </span>
                                            
                                            <input
                                                type="file"
                                                onChange={this.uploadAvatar}
                                                accept="image/*" 
                                            />
                                        </span>
                                    </div>
                                    
                                </div>
                            </div>
                            
                            <SettingsFormBig
                                parentProps = {this.props}
                                onBasicInfoUpdate = {this.onBasicInfoUpdate}
                                onContactsInfoUpdate = {this.onContactsInfoUpdate}
                            />
                        </div>
                        <div className="col-sm-4">
                            <SettingsFormSide
                                parentProps = {this.props}
                                // onInfoUpdate = {this.onInfoUpdate}
                                onBasicInfoUpdate = {this.onBasicInfoUpdate}
                                onContactsInfoUpdate = {this.onContactsInfoUpdate}
                                updateUser={this.updateUser}
                            />
                        </div>
                    </div>    
        )
    }
}


Settings.propTypes = {
    onBasicInfoUpdate: PropTypes.func.isRequired,
    onContactsInfoUpdate: PropTypes.func.isRequired,
    infoContacts: PropTypes.object.isRequired,
};

export default Settings;


// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js